import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import { apiClient, extractApiError } from '../api/axios';
import { API } from '../constants/api';
import { DEFAULT_PAGE_SIZE } from '../constants/ui';

const initialState = {
  page: 1,
  pageSize: DEFAULT_PAGE_SIZE,
  total: null,
  loading: false,
  modal: false,
  error: '',
  success: false,
  deleted: false,
  partners: [],

  update: false,
};

export const fetchPartners = createAsyncThunk('partners/fetchPartners', async (_, { rejectWithValue }) => {
  try {
    const response = await apiClient.get(API.vendors.requestToVendor);
    return response.data;
  } catch (error) {
    return rejectWithValue(extractApiError(error));
  }
});

export const partnersSlice = createSlice({
  name: 'partners',
  initialState,
  extraReducers: (builder) => {
    builder.addCase(fetchPartners.pending, (state) => {
      state.loading = true;
      state.error = '';
      state.success = false;
    });
    builder.addCase(fetchPartners.fulfilled, (state, action) => {
      state.loading = false;
      state.page = action.payload.page;
      state.pageSize = action.payload.page_size;
      state.total = action.payload.total;
      state.partners = action.payload.results;
      state.success = true;
    });
    builder.addCase(fetchPartners.rejected, (state, action) => {
      state.error = action.payload;
      toast.error(action.payload);
      state.loading = false;
      state.success = false;
    });
  },
  reducers: {
    resetStatus: (state) => {
      state.statusPostVendor = 'idle';
      state.errorPostVendor = '';
    },
    setUpdate: (state) => {
      state.update = !state.update;
    },
    setModal: (state, action) => {
      state.modal = action.payload;
    },
  },
});

export const { setModal, setUpdate, resetStatus } = partnersSlice.actions;

export default partnersSlice.reducer;
